import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EToolTip from '../others/EToolTip';
import SolarIcon from 'components/icons/SolarIcon';

export interface ListColumnItem {
    id: string;
    label: string;
    visible: boolean;
}

interface ListColumnsMenuProps {
    items: ListColumnItem[];
    onToggle: (id: string) => void;
    className?: string;
}

const ListColumnsMenu = ({ items, onToggle, className = '' }: ListColumnsMenuProps) => {
    const { t } = useTranslation('common');

    return (
        <Dropdown autoClose="outside" className={`d-inline-block ${className}`}>
            <EToolTip title={t('toolListColumns')}>
                <span className="d-inline-block">
                    <Dropdown.Toggle
                        className="fs-14 px-2 toolbar-icon-btn"
                        size="sm"
                        id="registry-columns-menu"
                    >
                        <SolarIcon name="columns" className="fs-14 p-0" />
                    </Dropdown.Toggle>
                </span>
            </EToolTip>
            <Dropdown.Menu>
                {items.map((item) => (
                    <Dropdown.Item
                        key={item.id}
                        as="button"
                        type="button"
                        onClick={() => onToggle(item.id)}
                    >
                        <span className="d-inline-flex align-items-center">
                            <span className="list-columns-menu__check d-inline-flex justify-content-center me-2">
                                {item.visible ? <SolarIcon name="check-lg" className="fs-14 p-0" /> : null}
                            </span>
                            {item.label}
                        </span>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ListColumnsMenu;
